import { Component, input, output } from "@angular/core";
import { AssertionWithDetails } from "../../../../domains/assertions/services/assertion.service";

@Component({
  selector: "looks-good-item",
  standalone: true,
  templateUrl: "./looks-good-item.component.html",
  styleUrls: ["./looks-good-item.component.scss"],
})
export class LooksGoodItemComponent {
  assertionWithDetail = input.required<AssertionWithDetails>();
  navToIssue = output<AssertionWithDetails>();
}
